/** First season start year shown in season dropdowns (label 2019/2020). */
export const SEASON_MIN_START_YEAR = 2019;

/**
 * Seasons after the current one included in dropdowns (e.g. current 2025/2026 → max 2028/2029).
 */
export const SEASON_MAX_YEARS_AHEAD = 3;

/**
 * Season runs 1 Sep – 31 Aug; label is startYear/(startYear+1).
 * Before September, the active season started the previous calendar year.
 */
export function getSeasonStartYear(date: Date = new Date()): number {
    const month = date.getMonth();
    const year = date.getFullYear();
    return month >= 8 ? year : year - 1;
}

export function formatSeasonLabel(startYear: number): string {
    return `${startYear}/${startYear + 1}`;
}

export function getCurrentSeasonLabel(date?: Date): string {
    return formatSeasonLabel(getSeasonStartYear(date ?? new Date()));
}

export function getMaxSeasonStartYear(date?: Date): number {
    return getSeasonStartYear(date ?? new Date()) + SEASON_MAX_YEARS_AHEAD;
}

export function getSeasonSelectOptions(
    date?: Date,
    includeValue?: string
): { value: string; label: string }[] {
    const maxStart = getMaxSeasonStartYear(date);
    const options: { value: string; label: string }[] = [];

    for (let startYear = maxStart; startYear >= SEASON_MIN_START_YEAR; startYear--) {
        const label = formatSeasonLabel(startYear);
        options.push({ value: label, label });
    }

    if (includeValue && !options.some((o) => o.value === includeValue)) {
        options.unshift({ value: includeValue, label: includeValue });
    }

    return options;
}
